/** Italiano. */
export default {
  common: {
    loading: 'Caricamento…',
    loadingProject: 'Caricamento progetto…',
    cancel: 'Annulla',
    optional: '(opzionale)',
    you: 'te',
    dash: '—',
    serverError: 'Errore {{status}}',
  },
  lang: {
    label: 'Lingua',
  },
  nav: {
    projects: 'Progetti',
    tecnico: 'Ufficio tecnico',
    admin: 'Amministrazione',
    logout: 'Esci',
  },
  roles: {
    USER: 'Utente',
    TECNICO: 'Tecnico',
    ADMIN: 'Admin',
    badgeAdmin: 'admin',
    badgeTecnico: 'tecnico',
  },
  craneType: {
    CINGOLATA: 'Gru cingolata',
    RAGNO: 'Gru ragno',
    AUTOCARRATA: 'Gru autocarrata',
    TORRE: 'Gru a torre',
  },
  login: {
    titleLogin: 'Accedi al configuratore',
    titleRegister: 'Crea un account',
    subtitle: 'Configuratore 3D gru BGLift',
    name: 'Nome',
    email: 'Email',
    password: 'Password',
    submitLogin: 'Accedi',
    submitRegister: 'Registrati',
    toggleToRegister: 'Non hai un account? Registrati',
    toggleToLogin: 'Hai già un account? Accedi',
  },
  dashboard: {
    title: 'I tuoi progetti',
    subtitle: 'Configurazioni di sollevamento salvate',
    newProject: '+ Nuovo progetto',
    empty: 'Nessun progetto ancora: creane uno per iniziare a configurare la gru.',
    createFirst: 'Crea il primo progetto',
    byUser: 'di {{name}}',
    updated: 'Aggiornato {{date}}',
    certificatePdf: 'Certificato PDF',
    resend: 'Invia di nuovo per conferma',
    sendForReview: 'Invia per conferma ufficio tecnico',
    openConfigurator: 'Apri configuratore',
    deleteTitle: 'Elimina progetto',
    confirmDelete: 'Eliminare il progetto “{{name}}”?',
    modalTitle: 'Nuovo progetto',
    modalSubtitle: 'Scegli tipo e modello di gru: potrai configurarla nella scena 3D.',
    projectName: 'Nome progetto',
    projectNamePlaceholder: 'Es. Cantiere Via Roma',
    craneType: 'Tipo gru',
    selectType: 'Seleziona il tipo…',
    model: 'Modello',
    selectModel: 'Seleziona il modello…',
    createProject: 'Crea progetto',
    creating: 'Creazione…',
  },
  configurator: {
    backToProjects: 'Torna ai progetti',
    back: 'Progetti',
    savedAt: 'Salvato {{time}}',
    save: 'Salva',
    saving: 'Salvataggio…',
  },
  tecnico: {
    title: 'Ufficio tecnico',
    subtitle: 'Richieste di conferma configurazione dai clienti',
    empty: 'Nessuna richiesta in coda. Le nuove richieste dei clienti compariranno qui.',
    requestedBy: 'Richiesta di {{name}} ({{email}}) · inviata {{date}}',
    assignedTo: 'In carico a {{name}}',
    openConfiguration: 'Apri configurazione',
    claim: 'Prendi in carico',
    certify: 'Allega PDF e certifica',
    certifying: 'Caricamento…',
  },
  admin: {
    title: 'Amministrazione',
    subtitle: 'Gestione utenti e catalogo modelli gru',
    tabUsers: 'Utenti',
    tabModels: 'Modelli gru',
  },
  users: {
    newUser: '+ Nuovo utente',
    colUser: 'Utente',
    colRole: 'Ruolo',
    colStatus: 'Stato',
    colProjects: 'Progetti',
    colActions: 'Azioni',
    active: 'Attivo',
    inactive: 'Disattivato',
    resetPassword: 'Reset password',
    deactivate: 'Disattiva',
    reactivate: 'Riattiva',
    delete: 'Elimina',
    modalTitle: 'Nuovo utente',
    name: 'Nome',
    email: 'Email',
    password: 'Password',
    role: 'Ruolo',
    createUser: 'Crea utente',
    creating: 'Creazione…',
    promptResetPassword: 'Nuova password per {{email}} (min 6 caratteri):',
    passwordUpdated: 'Password aggiornata.',
    confirmDelete: 'Eliminare definitivamente {{email}}? Verranno eliminati anche i suoi {{count}} progetti.',
  },
  models: {
    newModel: '+ Nuovo modello',
    colCode: 'Codice',
    colName: 'Nome',
    colType: 'Tipo',
    colFile3d: 'File 3D',
    colProjects: 'Progetti',
    colStatus: 'Stato',
    colActions: 'Azioni',
    active: 'Attivo',
    inactive: 'Disattivato',
    deactivate: 'Disattiva',
    activate: 'Attiva',
    delete: 'Elimina',
    confirmDelete: 'Eliminare il modello {{code}}?',
    modalTitle: 'Nuovo modello gru',
    modalSubtitle:
      'Servono il file 3D (.glb) e il file JSON con i dati tecnici (geometrie, tabella di carico, configurazione di default — stessa struttura di BR0089.json).',
    code: 'Codice',
    codePlaceholder: 'Es. BR0100',
    craneType: 'Tipo gru',
    name: 'Nome',
    namePlaceholder: 'Es. BGLift BR0100',
    description: 'Descrizione',
    file3d: 'File 3D (.glb)',
    dataFile: 'Dati tecnici (.json)',
    createModel: 'Crea modello',
    creating: 'Caricamento…',
  },
  controls: {
    realtimeCalc: 'Calcolo portata in tempo reale',
    reset: 'Reset',
    resetField: 'Azzera',
    restore: 'Ripristina',
    legFrontLeft: 'Ant. sinistra',
    legFrontRight: 'Ant. destra',
    legRearLeft: 'Post. sinistra',
    legRearRight: 'Post. destra',
    groupLoad: 'Carico',
    loadWeight: 'Peso sollevato',
    maxSwl: 'Portata max (SWL)',
    loadUtil: 'Utilizzo carico',
    groupAerial: 'Gruppo aereo',
    boom: 'Braccio',
    angle: 'Angolo',
    extensionStroke: 'Corsa sfilo',
    borePressure: 'Pressione fondello',
    rodPressure: 'Pressione stelo',
    turretRotation: 'Rotazione torretta',
    workRadius: 'Raggio di lavoro',
    jib: 'Jib',
    jibAngle: 'Angolo jib',
    groupGround: 'Gruppo terra',
    opening: 'Apertura',
    footHeight: 'Alt. piede',
    knee: 'Ginocchio',
    groundHelp:
      'Apertura e Ginocchio hanno posizioni fisse (fori sulla macchina), regolabili gamba per gamba: apertura 0° = ripiegata lungo il carro, {{deg}}° = tutta aperta; ginocchio 0° = stinco in posa di progetto. Alt. piede: 0 = piede a terra, valori positivi = piede su un appoggio più alto (resta comunque appoggiato e portante). Le reazioni usano le posizioni reali dei piedi ricavate da apertura, ginocchio e alt. piede (geometria dal disegno BGLift); le masse macchina restano indicative.',
    disclaimer:
      "Prototipo con dati SWL indicativi. Validare sempre contro la tabella ufficiale BGLift e la normativa EN 13000 prima dell'uso in cantiere.",
  },
  status: {
    safe: 'IN SICUREZZA',
    warning: 'ATTENZIONE',
    critical: 'CRITICO — STOP',
    shortSafe: 'OK',
    shortWarning: 'ATT.',
    shortCritical: 'STOP',
    calculating: 'Calcolo in corso…',
    radius: 'Raggio',
    swl: 'SWL',
    loadUtil: 'Util. carico',
    padUtil: 'Util. pad max',
    tippingMargin: 'Margine ribaltamento',
    en13000: 'EN 13000 — ribaltamento a 0% · soglia di attenzione a 20%',
    controls: 'Controlli',
  },
  review: {
    requested: 'Inviata all’ufficio tecnico',
    inReview: 'In carico all’ufficio tecnico',
    certified: 'Configurazione certificata',
    certificatePdf: 'Certificato PDF',
    sending: 'Invio…',
    resend: 'Invia di nuovo per conferma',
    send: 'Invia per conferma ufficio tecnico',
  },
  crane3d: {
    loading: 'Caricamento…',
  },
}
